import React from "react";

export const SettingsTabContext = React.createContext();
